import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { EventAvailable as ScheduledIcon } from '@mui/icons-material';

import { GlobalButton, NavigateLinks } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';

import { childrenBusinessPageBreadcrumbs } from '../../config';
import { PickUpSearchBar, PickUpTable } from './components';
import { usePickUpPagination, usePickUpFilter, usePickUps } from './hooks';

const PickUp = () => {
  const navigate = useNavigate();

  const breadcrumbs = useMemo(
    () => childrenBusinessPageBreadcrumbs(navigate),
    [navigate]
  );

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePickUpPagination();

  const { filters, setFilters, initialFilter } = usePickUpFilter();

  const applyFilters = (newFilters: any) => {
    setFilters(newFilters);
    handlePageChange(1);
  };

  const { pickUps, totalItems, totalPages, totalPicked, isLoading } = usePickUps({
    page: currentPage,
    pageSize,
    filters,
  });

  return (
    <section className='w-full h-full flex flex-col gap-6 mb-12'>
      <div className='flex flex-col'>
        <NavigateLinks actualPage='Retiros Flex' breadcrumbs={breadcrumbs} />
        <div className='flex justify-end'>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={() => navigate('/business/pickup-cycles')}
          >
            <ScheduledIcon />
            Retiros agendados
          </GlobalButton>
        </div>
      </div>

      <section className='w-full flex flex-col gap-6'>
        <PickUpSearchBar
          search={applyFilters}
          initialFilter={initialFilter}
          filter={filters}
        />

        <PickUpTable
          pickUps={pickUps}
          isLoading={isLoading}
          totalItems={totalItems}
          totalPages={totalPages}
          totalPicked={totalPicked}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          onViewDetails={(id) => navigate(`/business/pickup/${id}`)}
        />
      </section>
    </section>
  );
};

export default PickUp;
